import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { NavController } from '@ionic/angular';

import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  authService = inject(AuthService);
  firestore = inject(Firestore);

  constructor(private navCtrl: NavController) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const user = await this.authService.getUser();

      console.log('AdminGuard next:', next);
      console.log('AdminGuard state:', state);

      if (!user) {
        console.log('AdminGuard: User is not logged in');
        await this.navCtrl.navigateForward(['login']);
        return false;
      }

      const userRef = doc(this.firestore, `userProfile/${user.uid}`);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        console.log('AdminGuard: User document does not exist');
        await this.navCtrl.navigateRoot(['home']);
        return false;
      }

      const userData = userSnap.data();

      const isAdmin = userData?.['role'] === 'admin';

      if (!isAdmin) {
        console.log('AdminGuard: User is not admin');
        await this.navCtrl.navigateRoot(['home']);
        return false;
      }

      return true;
    } catch (err) {
      console.error('AdminGuard error', err);
      await this.navCtrl.navigateRoot(['home']);
      return false;
    }
  }
}
